/**
 *
 * @module entry
 * @desc {SDK.Purchase} entry point.
 *
 */

import PurchaseApi from './purchaseApi';
import PurchaseManager from './purchaseManager';
import AccessStatus from './accessStatus';
import Purchases from './purchases';
import Receipt from './receipt';
import PurchaseType from './purchaseType';
import RedeemRetryHandler from './redeemRetryHandler';

/**
 *
 * @typedef SDK.Purchase
 * @type {Object}
 *
 * @property {SDK.Purchase.PurchaseApi} PurchaseApi
 * @property {SDK.Purchase.PurchaseManager} PurchaseManager
 * @property {SDK.Purchase.AccessStatus} AccessStatus
 * @property {SDK.Purchase.Purchases} Purchases
 * @property {SDK.Purchase.Receipt} Receipt
 * @property {SDK.Purchase.PurchaseType} PurchaseType
 * @property {SDK.Purchase.RedeemRetryHandler} RedeemRetryHandler
 *
 */

/**
 *
 * @type {SDK.Purchase}
 *
 */
export default {

    PurchaseApi,
    PurchaseManager,
    AccessStatus,
    Purchases,
    Receipt,
    PurchaseType,
    RedeemRetryHandler

};



// WEBPACK FOOTER //
// ./src/purchase/entry.js